var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3923 15.1334H18.5169C19.8094 15.1334 21.049 14.6199 21.9629 13.706C22.8769 12.792 23.3903 11.5525 23.3903 10.26C23.3903 8.96747 22.8769 7.7279 21.9629 6.81396C21.049 5.90002 19.8094 5.38658 18.5169 5.38658H18.3295C17.7647 4.13383 16.8102 3.09718 15.6081 2.43122C14.4061 1.76526 13.0211 1.50566 11.6595 1.69114C10.2979 1.87662 9.03271 2.49724 8.05262 3.46045C7.07254 4.42366 6.43005 5.67787 6.22096 7.03603C5.65804 6.88063 5.06852 6.84657 4.49145 6.9361C3.91437 7.02563 3.36289 7.23671 2.87351 7.55537C2.38413 7.87403 1.96802 8.293 1.65271 8.78455C1.33741 9.27609 1.1301 9.829 1.04452 10.4067C0.95894 10.9844 0.997033 11.5736 1.15628 12.1355C1.31553 12.6973 1.59229 13.2189 1.96826 13.6658C2.34423 14.1127 2.81082 14.4746 3.33716 14.7276C3.86349 14.9806 4.43756 15.1189 5.02136 15.1334H6.89574",
    stroke: "white",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1435 8.38281V16.6301M9.14453 13.6311L12.1435 16.6301L15.1426 13.6311",
    stroke: "white",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.7ee2bae3273ec5a30a8982fca10b340d.svg";
export { ForwardRef as ReactComponent };